var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMedal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 24,
    viewBox: "0 0 18 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "path-1",
    d: "M0 0h18l-4 8-5.027-2L4 8z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("g", {
    id: "Leaderboard-Mobile---Race-Not-Started-(Registered)",
    transform: "translate(-43 -516)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Leaderboard-and-BG",
    transform: "translate(0 -2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Leaderboard",
    transform: "translate(-12 270)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Prize",
    transform: "translate(0 8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Trophy-Copy-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Medal",
    transform: "translate(55 240)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Medal-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ribbon"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    stroke: "#FFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.123 8.5h.582l4.419-8h-6.858l-1.28 2.319L12.122 8.5z",
    id: "Combined-Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.847.5l4.419 8h6.858L7.705.5H.847z",
    id: "Rectangle"
  }))), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#FFF",
    strokeWidth: 1.125,
    fillRule: "nonzero",
    cx: 9,
    cy: 15,
    r: 8.438
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.275 18.131l-.435-2.533 1.84-1.794-2.543-.37L9 11.13l-1.137 2.304-2.544.37 1.84 1.794-.434 2.533L9 16.935l2.275 1.196z",
    id: "Star",
    stroke: "#FFF",
    fillRule: "nonzero"
  })))))))))));
}
SvgMedal.displayName = 'Medal';
export default SvgMedal;